import { isEmpty } from 'lodash';
import FileDownload from 'react-file-download';
import { actions } from 'forms/rrf';
import { toast } from 'react-toastify';
import ToastMessage from '../components/common/toast-message';
import irelandApi from '../irelandApi';
import {
  ADD_POSTCODE_PLAN_FULFILLED,
  ADD_POSTCODE_PLAN_PENDING,
  ADD_POSTCODE_PLAN_REJECTED,
  GET_POSTCODE_PLAN_FULFILLED,
  GET_POSTCODE_PLAN_META_FULFILLED,
  GET_POSTCODE_PLAN_META_PENDING,
  GET_POSTCODE_PLAN_META_REJECTED,
  GET_POSTCODE_PLAN_OBJECTIVES_FULFILLED,
  GET_POSTCODE_PLAN_OBJECTIVES_PENDING,
  GET_POSTCODE_PLAN_OBJECTIVES_REJECTED,
  GET_POSTCODE_PLAN_PENDING,
  GET_POSTCODE_PLAN_REJECTED,
  UPDATE_POSTCODE_PLAN_FULFILLED,
  UPDATE_POSTCODE_PLAN_PENDING,
  UPDATE_POSTCODE_PLAN_REJECTED
} from '../reducers/postcodePlanReducer';
import { history } from '../store';
import {
  destandard,
  objectToFormData,
  removeNullFieldsFromJson
} from '../utils/commonFunctions';

const preparePostcodePlanPayload = (payLoad) => {
  const brandIds = payLoad.products.map(product => product.brand.id);

  const postcodePlanData = {
    objective: removeNullFieldsFromJson(payLoad),
    brand_points: { points: [] },
    thresholds: [],
    opt_in_bonus_outlets: { file: '' }
  };
  postcodePlanData.objective.group_ids = [];
  const {
    products, brand_points: brandPoints, thresholds, opt_in_bonus_outlets: optInBonusOutlets
  } = postcodePlanData.objective;

  if (postcodePlanData.objective.groups) {
    postcodePlanData.objective.group_ids = postcodePlanData.objective.groups.map(curr => curr.value);
    delete postcodePlanData.objective.groups;
  }

  if (postcodePlanData.objective.abm_codes) {
    postcodePlanData.objective.postcodeplan_objectives_abms_attributes =
      postcodePlanData.objective.abm_codes.map(curr => ({ abm_code: curr.value }));
  }

  if (postcodePlanData.objective.wse_bands) {
    postcodePlanData.objective.postcodeplan_objectives_wse_bands_attributes =
      postcodePlanData.objective.wse_bands.map(curr => ({ wse_band: curr.value }));
  }

  if (postcodePlanData.objective.postcodes) {
    postcodePlanData.objective.postcodeplan_objectives_postcodes_attributes =
      postcodePlanData.objective.postcodes.map(curr => ({ postcode: curr.value }));
  }

  if (postcodePlanData.objective.sub_zones) {
    postcodePlanData.objective.postcodeplan_objectives_sub_zones_attributes =
    postcodePlanData.objective.sub_zones.map(curr => ({ horizon_sub_zone_id: curr.value }));
  }

  if (postcodePlanData.objective.zones) {
    postcodePlanData.objective.postcodeplan_objectives_zones_attributes =
    postcodePlanData.objective.zones.map(curr => ({ horizon_zone_id: curr.value }));
  }

  if (products) {
    postcodePlanData.objective.product_ids = products.map(product => product.value);
    delete postcodePlanData.objective.products;
  }

  if (!isEmpty(brandPoints)) {
    postcodePlanData.brand_points.points = Object.keys(brandPoints)
      .map((brand) => {
        const brandId = +brand.split('-')[1];
        if (!brandIds.includes(brandId)) {
          return null;
        }

        return {
          brand_id: brandId,
          points: brandPoints[brand].points
        };
      }).filter(n => n);
    delete postcodePlanData.objective.brand_points;
  }

  if (!isEmpty(thresholds)) {
    postcodePlanData.thresholds = Object.entries(thresholds)
      .map(threshold => ({ abm_code: threshold[0].replace(/^(abm-code-)/, '').split('-').join('_'), value: threshold[1].threshold }));

    delete postcodePlanData.objective.thresholds;
  }

  if (optInBonusOutlets) {
    postcodePlanData.opt_in_bonus_outlets.file = optInBonusOutlets;

    delete postcodePlanData.objective.opt_in_bonus_outlets;
  }

  return objectToFormData(postcodePlanData, 'postcodeplan_objective');
};

export const getPostcodePlanObjectives = (name, dateFrom, dateTo) => (dispatch) => {
  dispatch({ type: GET_POSTCODE_PLAN_OBJECTIVES_PENDING, payload: [] });
  const q = {
    name,
    end_date_from: dateFrom,
    end_date_to: dateTo,
  };
  return irelandApi.get('/api/admin/postcodeplan_objectives', {params: {q}})
    .then((response) => {
      dispatch({
        type: GET_POSTCODE_PLAN_OBJECTIVES_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_POSTCODE_PLAN_OBJECTIVES_REJECTED,
        payload: error.data
      });
      return Promise.reject(error.response.data);
    });
};

export const getPostcodePlan = id => (dispatch) => {
  dispatch({ type: GET_POSTCODE_PLAN_PENDING, payload: [] });
  return irelandApi.get(`/api/admin/postcodeplan_objectives/${id}`)
    .then((response) => {
      const data = destandard({...response.data.data.attributes});

      dispatch({
        type: GET_POSTCODE_PLAN_FULFILLED,
        payload: data
      });
      dispatch(actions.load('deep.postcode_plan', data));
    })
    .catch((error) => {
      dispatch({
        type: GET_POSTCODE_PLAN_REJECTED,
        payload: error.response
      });
      return Promise.reject(error.response.data.errors);
    });
};

export const getPostcodePlanMeta = () => (dispatch) => {
  dispatch({ type: GET_POSTCODE_PLAN_META_PENDING, payload: [] });
  return irelandApi.get('/api/admin/postcodeplan_objectives/meta')
    .then((response) => {
      dispatch({
        type: GET_POSTCODE_PLAN_META_FULFILLED,
        payload: response.data.meta
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_POSTCODE_PLAN_META_REJECTED,
        payload: error.response
      });
      return Promise.reject(error.response.data.errors);
    });
};

export const createPostcodePlan = (payLoad, dispatch) => {
  const formData = preparePostcodePlanPayload(payLoad);

  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };

  dispatch({ type: ADD_POSTCODE_PLAN_PENDING });
  return irelandApi.post('/api/admin/postcodeplan_objectives', formData, config)
    .then(() => {
      dispatch({
        type: ADD_POSTCODE_PLAN_FULFILLED,
      });
      toast.success(<ToastMessage iconStyle='success' message='Postcode plan objective created successfully' />);
      history.push('/admin/objectives/postcode-plans');
    })
    .catch((error) => {
      const errorPayload = error.response.data.errors;

      dispatch({
        type: ADD_POSTCODE_PLAN_REJECTED,
        payload: errorPayload
      });
      if (errorPayload.opt_in_bonus_outlets) {
        dispatch(actions.setErrors('deep.postcode_plan.opt_in_bonus_outlets', errorPayload.opt_in_bonus_outlets));
      }
      toast.error(<ToastMessage iconStyle='error' message={error.response.data.message} />);
      return Promise.reject(errorPayload);
    });
};

export const updatePostcodePlan = (id, payLoad, dispatch) => {
  const formData = preparePostcodePlanPayload(payLoad);
  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };

  dispatch({ type: UPDATE_POSTCODE_PLAN_PENDING });

  return irelandApi.patch(`/api/admin/postcodeplan_objectives/${id}`, formData, config)
    .then((response) => {
      dispatch({
        type: UPDATE_POSTCODE_PLAN_FULFILLED,
        payload: response.data
      });
      toast.success(<ToastMessage iconStyle='success' message='Postcode plan objective updated successfully' />);
      history.push('/admin/objectives/postcode-plans');
    })
    .catch((error) => {
      dispatch({
        type: UPDATE_POSTCODE_PLAN_REJECTED,
        payload: error.response.data.errors
      });
      toast.error(<ToastMessage iconStyle='error' message='An error occurred during update postcode plan objective' />);
      return Promise.reject(error.response.data.errors);
    });
};

export const downloadPostcodePlan = id => () => irelandApi.get(`/api/admin/postcodeplan_objectives/${id}/download`)
  .then((response) => {
    let filename = 'postcode-plan.csv';
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(response.headers['content-disposition']);
    if (matches && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
    FileDownload(response.data, filename);
  })
  .catch(() => {
  });
